export default __webpack_public_path__ + "static/media/book.cdcd8be9.png";